import React from 'react';
import { Outlet } from 'react-router-dom';

const MaintanceDeptStatMngPage = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default MaintanceDeptStatMngPage;
